import homeFiltersReducer from "utils/redux/Home/homeFilters";
import resultReducer from "utils/redux/Optimization/resultSlice";
import supportReducer from "./support/supportSlice";
import mainDropDownReducer from "./menus/mainDropdownDataSlice";
import maintenanceSlice from "utils/redux/maintenance/maintenanceSlice";
import addScenarioReducer from "./Optimization/addScenarioSlice";
import featureFlagsSlice from "./featureFlags/featureFlagsSlice";
import homePageReducer from "./Home/homePage";

export const rootReducer = {
  addScenario: addScenarioReducer,
  homeFilters: homeFiltersReducer,
  maintenance: maintenanceSlice,
  featureFlags: featureFlagsSlice,
  result: resultReducer,
  support: supportReducer,
  mainDropDownData: mainDropDownReducer,
  homePage: homePageReducer,
};
